import { render, staticRenderFns } from "./asinfo.vue?vue&type=template&id=35c84d49&scoped=true"
import script from "./asinfo.vue?vue&type=script&lang=js"
export * from "./asinfo.vue?vue&type=script&lang=js"
import style0 from "./asinfo.vue?vue&type=style&index=0&id=35c84d49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c84d49",
  null
  
)

export default component.exports